import type { ContainerStatusEntity } from "@ots-frontend/ots-data";
import { OtsTooltip } from "../components/OtsTooltip";
import { useOtsColorScheme } from "../theme/OtsTheme";
import { type ContainerStatusIconVariant, resolveContainerStatusIcons, useContainerStatusIconSet } from "./container-status-icons";

export type ContainerStatusIndicatorsProps = {
  status: ContainerStatusEntity;
  variant?: ContainerStatusIconVariant;
  /** Also shows the stale-poll clock, when the host's display options say the poll is stale. */
  stalePoll?: boolean;
  size?: number;
};

/** The status column's icons as a labeled row, like the indicators on FieldGo's container sheet. */
export const ContainerStatusIndicators = ({ status, variant = "filled", stalePoll, size = 20 }: ContainerStatusIndicatorsProps) => {
  const set = useContainerStatusIconSet();
  const scheme = useOtsColorScheme() ?? "light";
  const icons = resolveContainerStatusIcons(status, variant, set, scheme, { stalePoll });
  if (!icons.length) return null;
  return (
    <ul aria-label="Status" className="flex flex-wrap items-center gap-1.5">
      {icons.map((icon) => (
        <li key={icon.name} className="flex">
          <OtsTooltip content={icon.label} density="compact">
            <img tabIndex={0} src={icon.src} alt={icon.label} width={size} height={size}
              className="overflow-hidden rounded outline-none focus-visible:ring-2 focus-visible:ring-[var(--ots-primary)]"/>
          </OtsTooltip>
        </li>
      ))}
    </ul>
  );
};
